var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup108(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5665 2.4292C12.8951 1.57412 14.1049 1.57412 14.4335 2.42919L16.9814 9.0598C17.086 9.33212 17.3044 9.54517 17.5792 9.64309L24.3564 12.058C25.2422 12.3736 25.2422 13.6264 24.3564 13.942L17.5792 16.3569C17.3044 16.4548 17.086 16.6679 16.9814 16.9402L14.4335 23.5708C14.1049 24.4259 12.8951 24.4259 12.5665 23.5708L10.0186 16.9402C9.91399 16.6679 9.69564 16.4548 9.42083 16.3569L2.64358 13.942C1.75779 13.6264 1.75779 12.3736 2.64359 12.058L9.42083 9.64309C9.69564 9.54517 9.91399 9.33212 10.0186 9.0598L12.5665 2.4292Z",
    fill: "url(#paint0_linear_896_11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02431 2.46917C5.17368 2.00786 5.82632 2.00786 5.97569 2.46917L6.37491 3.70217C6.41962 3.84028 6.52215 3.95213 6.65585 4.00867L7.91105 4.53949C8.31805 4.71161 8.31805 5.28839 7.91105 5.46051L6.65585 5.99133C6.52215 6.04787 6.41962 6.15973 6.37491 6.29783L5.97569 7.53083C5.82632 7.99214 5.17368 7.99214 5.02431 7.53083L4.62509 6.29783C4.58038 6.15972 4.47785 6.04787 4.34415 5.99133L3.08895 5.46051C2.68195 5.28839 2.68195 4.71161 3.08895 4.53949L4.34415 4.00867C4.47785 3.95213 4.58038 3.84028 4.62509 3.70217L5.02431 2.46917Z",
    fill: "url(#paint1_linear_896_11)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_896_11",
    x1: 36,
    y1: -5.5,
    x2: -1.96073e-7,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA6B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377222,
    stopColor: "#4C59E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E298F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_896_11",
    x1: 5.5,
    y1: 1,
    x2: 5.5,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0788F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57CF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup108);
export default __webpack_public_path__ + "static/media/Group108.cbc781e4f640239717e51e3d435852e3.svg";
export { ForwardRef as ReactComponent };